{
  "login": "Log Masuk",
  "logout": "Log Keluar",
  "signOut": "Log Keluar",
  "username": "Nama Pengguna",
  "password": "Kata Laluan",
  "forgotPassword": "Lupa Kata Laluan?",
  "rememberMe": "Ingat saya",
  "loginButton": "Log Masuk",
  "loginError": "Nama pengguna atau kata laluan tidak sah",
  "sessionExpired": "Sesi anda telah tamat tempoh. Sila log masuk semula.",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "Sedang log masuk...",
  "loginSuccess": "Berjaya log masuk",
  "showPassword": "Tunjukkan kata laluan",
  "hidePassword": "Sembunyikan kata laluan",
  "onboardingPrompt": "Untuk hospital atau klinik anda?",
  "onboardingCta": "Mohon onboarding",
  "loginFailed": "Log masuk gagal",
  "seatCapReached": "Had pengguna untuk lesen ini telah dicapai. Hubungi pentadbir anda.",
  "mfaCodeLabel": "Kod pengesahan",
  "mfaCodePrompt": "Masukkan kod 6 digit daripada aplikasi pengesah anda untuk melengkapkan log masuk.",
  "mfaSetupRequired": "Organisasi anda mewajibkan pengesahan berbilang faktor. Sediakan aplikasi pengesah anda untuk meneruskan.",
  "mfaCodePlaceholder": "Kod 6 digit",
  "mfaInvalidCode": "Kod pengesahan tidak sah",
  "pages": {
    "userProfile": {
      "title": "Profil Saya",
      "loading": "Memuatkan profil...",
      "sections": {
        "profilePicture": "Gambar Profil",
        "personalInformation": "Maklumat Peribadi",
        "changePassword": "Tukar Kata Laluan",
        "multiFactorAuth": "Pengesahan Pelbagai Faktor"
      },
      "fields": {
        "fullName": "Nama Penuh",
        "email": "E-mel",
        "phone": "Telefon",
        "currentPassword": "Kata Laluan Semasa",
        "newPassword": "Kata Laluan Baharu",
        "confirmPassword": "Sahkan Kata Laluan Baharu",
        "required": "*"
      },
      "actions": {
        "saveChanges": "Simpan Perubahan",
        "changePassword": "Tukar Kata Laluan",
        "setUpMfa": "Sediakan Pengesahan Pelbagai Faktor",
        "uploadAvatar": "Muat Naik",
        "changeAvatar": "Tukar",
        "removeAvatar": "Buang",
        "verify": "Sahkan"
      },
      "avatar": {
        "alt": "Avatar",
        "helperText": "PNG, JPEG atau WebP, sehingga 4 MB. Diubah saiz kepada {{size}}×{{size}} sebelum dimuat naik."
      },
      "mfa": {
        "enabledMessage": "Pengesahan pelbagai faktor telah diaktifkan untuk akaun anda.",
        "intro": "Aktifkan pengesahan pelbagai faktor untuk menambah lapisan keselamatan pada akaun anda.",
        "scanInstruction": "Imbas URI ini dengan aplikasi pengesah anda, atau salin secara manual:",
        "copyUri": "Salin URI",
        "verificationCode": "Kod Pengesahan",
        "codePlaceholder": "Masukkan kod 6 digit"
      },
      "validation": {
        "fullNameRequired": "Nama penuh diperlukan",
        "emailRequired": "Sila masukkan e-mel yang sah",
        "currentPasswordRequired": "Kata laluan semasa diperlukan",
        "newPasswordTooShort": "Kata laluan mestilah sekurang-kurangnya 8 aksara",
        "confirmPasswordRequired": "Sila sahkan kata laluan anda",
        "passwordsMismatch": "Kata laluan tidak sepadan"
      },
      "toasts": {
        "profileUpdated": "Profil berjaya dikemas kini",
        "profileUpdateFailed": "Gagal mengemas kini profil",
        "passwordChanged": "Kata laluan berjaya ditukar",
        "passwordChangeFailed": "Gagal menukar kata laluan. Sila semak kata laluan semasa anda.",
        "mfaSetupFailed": "Gagal memulakan persediaan pengesahan pelbagai faktor",
        "mfaEnabled": "Pengesahan pelbagai faktor diaktifkan",
        "mfaInvalidCode": "Kod pengesahan tidak sah",
        "avatarUpdated": "Avatar dikemas kini",
        "avatarUpdateFailed": "Gagal mengemas kini avatar",
        "avatarRemoved": "Avatar dibuang",
        "avatarRemoveFailed": "Gagal membuang avatar",
        "imageTooLarge": "Imej mestilah di bawah 4 MB",
        "imageTooLargeServer": "Imej terlalu besar — cuba fail yang lebih kecil",
        "copiedToClipboard": "Disalin ke papan klip"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "Sesi anda akan tamat tempoh dalam masa kurang daripada 1 minit. Sila simpan kerja anda sekarang.",
      "expiringSoon_one": "Sesi anda akan tamat tempoh dalam {{count}} minit.",
      "expiringSoon_other": "Sesi anda akan tamat tempoh dalam {{count}} minit.",
      "extendButton": "Lanjutkan Sesi"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "Persediaan awal",
    "subtitle": "Cipta akaun pentadbir pertama untuk pemasangan ini.",
    "username": "Nama Pengguna",
    "password": "Kata Laluan",
    "confirmPassword": "Sahkan kata laluan",
    "fullName": "Nama penuh (pilihan)",
    "fullNamePlaceholder": "cth. Tan Wei Ming",
    "email": "E-mel (pilihan)",
    "submit": "Cipta akaun pentadbir",
    "submitting": "Sedang mencipta akaun…",
    "usernameHint": "3–64 aksara: huruf kecil, digit, titik, garis bawah dan sempang.",
    "passwordHint": "Sekurang-kurangnya 12 aksara, dengan huruf besar, huruf kecil, digit dan aksara khas.",
    "errUsername": "Gunakan 3–64 aksara: a–z, 0–9, titik, garis bawah atau sempang.",
    "errPasswordLength": "Kata laluan mestilah sekurang-kurangnya 12 aksara.",
    "errPasswordUpper": "Kata laluan mesti mengandungi huruf besar.",
    "errPasswordLower": "Kata laluan mesti mengandungi huruf kecil.",
    "errPasswordDigit": "Kata laluan mesti mengandungi digit.",
    "errPasswordSpecial": "Kata laluan mesti mengandungi aksara khas.",
    "errConfirmRequired": "Sila sahkan kata laluan.",
    "errConfirmMismatch": "Kata laluan tidak sepadan.",
    "errFullName": "Nama penuh mestilah 100 aksara atau kurang.",
    "errEmail": "Masukkan alamat e-mel yang sah.",
    "successTitle": "Akaun pentadbir dicipta",
    "successBody": "Akaun “{{username}}” telah sedia. Log masuk untuk meneruskan.",
    "goToLogin": "Pergi ke log masuk",
    "claimedTitle": "Persediaan telah selesai",
    "claimedBody": "Sistem ini sudah mempunyai pentadbir. Log masuk dengan akaun anda.",
    "networkError": "Tidak dapat menghubungi pelayan. Semak sambungan anda dan cuba lagi.",
    "retry": "Cuba lagi",
    "rateLimited": "Terlalu banyak percubaan. Tunggu seminit dan cuba lagi.",
    "usernameTaken": "Nama pengguna ini telah digunakan.",
    "submitFailed": "Tidak dapat mencipta akaun. Sila cuba lagi."
  }
}
